import { render } from "./SystemInfo.vue?vue&type=template&id=6eba8dcc&scoped=true"
import script from "./SystemInfo.vue?vue&type=script&lang=js"
export * from "./SystemInfo.vue?vue&type=script&lang=js"

import "./SystemInfo.vue?vue&type=style&index=0&id=6eba8dcc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\cashierpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eba8dcc"]])

export default __exports__